<template lang="pug">
  .wrap
    template(v-if='!showPlaceholder')

      page-title Your Surveys

      list-header(:on-search='search')
        router-link(slot='action' :to="{ name: 'insight:surveyCreate' }")
          el-button(type="primary") Add New Survey

      el-table(:data="list.results" empty-text="No entries" v-loading='loading' @sort-change='changeSort')
        el-table-column(width="80" align='center' label='Status' class-name='status-cell')
          template(slot-scope="scope")
            icon.status-icon(v-if='scope.row.status === "published"' name='check-circle' color='#7fc4be' :scale='1.5')
            icon.status-icon(v-if='scope.row.status === "draft"' name='times-circle' color='#dd6e69' :scale='1.5')

        el-table-column(label="Survey title" min-width="130" prop='title' sortable class-name='title-cell')
          template(slot-scope="scope")
            div(@click='navigateToEdit(scope.row.id)')
              | {{ scope.row.title }}

        el-table-column(label="Users Assigned" prop='tot_users_assigned' width="130" class-name='stat-cell' align='center' sortable)
          template(slot-scope="scope")
            | {{ scope.row.totUsersAssigned }}


        el-table-column(label="Completed" width="130" prop='completed_count' class-name='stat-cell' align='center' sortable)
          template(slot-scope="scope")
            | {{ scope.row.completedCount }} / {{ scope.row.targetNumReplies }}
            .stat-percentage {{ formatPercentage(scope.row.completedCount, scope.row.targetNumReplies) }} completed

        el-table-column(label="Time remaining" width="150" prop='minutes_remaining' class-name='stat-cell' align='center' sortable)
          template(slot-scope="scope")
            | {{ formatTimeRemaining(scope.row.endDatetime) }}

        el-table-column(width="140" align='center')
          template(slot-scope="scope")
            el-button(size='small' @click='navigateToReport(scope.row.id)')
              icon.report-icon(name='chart-bar' color='#999')
              | Report

        el-table-column(width='100' align='center')
          template(slot-scope="scope")
            check-permission(type='briefs' can='edit')
              el-button(size='small' @click='navigateToEdit(scope.row.id)')
                icon.report-icon(name='edit' color='#999')
                | Edit
      .pages
        el-pagination(layout="prev, pager, next" @current-change='changePage' :total="list.count" :page-size='pageSize')

    .empty(v-else)
      survey-list-empty
</template>

<script>
import { mapActions } from "vuex";
import distanceInWordsStrict from "date-fns/distance_in_words_strict";
import PageTitle from "@/shared/components/layout/PageTitle";
import ListHeader from "@/shared/components/ListHeader";
import SurveyListEmpty from "../SurveyListEmpty";

export default {
  components: { PageTitle, ListHeader, SurveyListEmpty },
  data() {
    return {
      loading: true,
      pageSize: 20,
      searchParams: null,
      list: {
        retults: [],
        count: 0
      }
    };
  },
  computed: {
    showPlaceholder() {
      return !this.loading && !this.searchParams && !this.list.count;
    }
  },
  methods: {
    ...mapActions("surveys", ["fetchSurveys"]),
    search(q) {
      if (q) {
        this.searchParams = { q };
      } else {
        this.searchParams = null;
      }
      this.loadList({ params: this.searchParams });
    },
    navigateToEdit(surveyId) {
      this.$router.push({ name: "insight:surveyEdit", params: { surveyId } });
    },
    navigateToReport(surveyId) {
      this.$router.push({ name: "insight:surveyReport", params: { surveyId } });
    },
    formatPercentage(num, tot) {
      const r = num / tot;
      return `${tot ? Math.floor(r * 100) : 0}%`;
    },
    formatTimeRemaining(time) {
      return time ? distanceInWordsStrict(time, new Date()) : "-";
    },
    loadList({ params } = {}) {
      const mergedParams = {
        pageSize: this.pageSize,
        ...params
      };
      this.loading = true;
      this.fetchSurveys({ params: mergedParams }).then(data => {
        this.loading = false;
        this.list = data;
      });
    },
    changeSort({ prop, order }) {
      if (!order) {
        this.loadList();
        return;
      }
      const sortVal = (order === "ascending" ? "" : "-") + prop;
      this.loading = true;
      this.loadList({ params: { sort: sortVal } });
    },
    changePage(page) {
      this.loadList({ params: { page } });
    }
  },
  created() {
    this.loading = true;
    this.loadList();
  },
  activated() {
    this.loading = true;
    this.loadList();
  }
};
</script>

<style lang="scss"></style>

<style scoped lang="scss">
.pages {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.emptystate {
  width: 100%;
}

.wrap {
  :global(.cell) {
    word-break: normal;
    line-height: 20px;
    text-transform: capitalize;
    padding: 10px 0;
  }

  :global(td.stat-cell .cell) {
    font-size: 16px;
    line-height: 20px;
    padding: 20px 0;
  }

  :global(td .cell) {
    line-height: 1.2em;
  }

  :global(.status-cell .cell) {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  :global(td.title-cell) {
    font-size: 16px;
    cursor: pointer;
  }
}

.stat-percentage {
  font-size: 11px;
  margin-top: 5px;
  color: #999;
}

.report-icon {
  margin-right: 8px;
}

.placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #999;
  border: 1px solid #ddd;
  border-radius: 2px;
  background: white;
  padding: 80px 0;
  flex-direction: column;
}

.placeholder-actions {
  margin-top: 30px;
}
</style>
